<div class="login-wrapper">
    <img src="assets/icons/main-icon.svg" alt="Logo Pass" class="logo" />
    <div class="login-box">

        <form (ngSubmit)="login()" #loginForm="ngForm">
            <label for="username">Usuario *</label>
            <input id="username" type="text" placeholder="Número de credencial" name="username"
                [(ngModel)]="numeroCredencial" required />

            <label for="password">Clave *</label>
            <input id="password" type="password" placeholder="Número de documento" name="password"
                [(ngModel)]="documentoNumero" required />

            <div class="remember-me">
                <input type="checkbox" id="remember" [(ngModel)]="rememberMe" name="remember" />
                <label for="remember">Recordarme</label>
            </div>

            <button type="submit" [disabled]="!loginForm.form.valid || isLoading">
                {{ isLoading ? 'Cargando...' : 'Acceder' }}
            </button>
        </form>

        <div *ngIf="loginFailed && errorMessage" class="error-message">
            {{ errorMessage }}
        </div>

        <p class="comercio-link">
            Si desea ingresar como un Comercio haga
            <a href="#">click aquí</a>.
        </p>
    </div>
</div>